import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import qs from 'query-string'
import Container from '@material-ui/core/Container'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined'
import CoachCardSm from 'components/coach-card-small'
import { useAuth } from 'lib/auth'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { get } from 'lodash'
import StepDescription from '../step-description'
import GroupedLessonTypes from './grouped-lesson-types'
import LocationDropdown from './location-dropdown'
import { useStyles } from './styles'

export default ({
  data,
  coach,
  coachIsViewingOwnSchedule,
  lessonCreditBalances,
}) => {
  const {
    coachName,
    coachTitle,
    coachAvatar,
    coachLocations,
    lessonTypes,
  } = data
  const [selectedFacility, setSelectedFacility] = useState(
    get(coachLocations, '0.id', null),
  )
  const [isLeadIntakeFormEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_LEAD_INTAKE_STEPPER_FORM,
  ])
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { idOrSlug } = useParams()
  const { isConsumer } = useAuth()
  const { returnTo } = qs.parse(location.search)

  const lessonTypesSingleLesson = {}
  const lessonTypesWithPacks = {}
  let hasLessonPacks = false

  const addSession = (recipient, lt, session) => {
    if (!Array.isArray(recipient[lt])) {
      recipient[lt] = []
    }
    recipient[lt].push(session)
  }

  for (const [lessonType, sessions] of Object.entries(lessonTypes)) {
    // eslint-disable-next-line
    sessions.forEach(session => {
      if (session.lessonPacks.length > 0) {
        hasLessonPacks = true
        addSession(lessonTypesWithPacks, lessonType, session)
        addSession(lessonTypesSingleLesson, lessonType, session)
      } else {
        addSession(lessonTypesSingleLesson, lessonType, session)
      }
    })
  }

  const handleGetInTouchClick = () => {
    history.push(`/coach/${idOrSlug}/schedule/intake-form`, { coach: coach })
  }

  return (
    <Container className={classes.root} pb={10}>
      <Grid container className={classes.columnReverse}>
        {isConsumer && !returnTo && (
          <Grid item xs={12}>
            <Box display="flex" flexGrow={1}>
              <Button
                href="/club"
                rel="noopener noreferrer"
                startIcon={<ArrowBackOutlinedIcon />}
              >
                {isConsumer ? 'Back to My Coach' : "Back To Coach's Profile"}
              </Button>
            </Box>
          </Grid>
        )}
        {!isConsumer && coach.profileUrl != null && !returnTo && (
          <Grid item xs={12}>
            <Box display="flex" flexGrow={1}>
              <Button
                href={coach.profileUrl}
                rel="noopener noreferrer"
                startIcon={<ArrowBackOutlinedIcon />}
              >
                Back To Coach's Profile
              </Button>
            </Box>
          </Grid>
        )}
        {returnTo && (
          <Grid item xs={12}>
            <Box display="flex" flexGrow={1}>
              <Button
                href={returnTo}
                rel="noopener noreferrer"
                startIcon={<ArrowBackOutlinedIcon />}
              >
                Back
              </Button>
            </Box>
          </Grid>
        )}
        <Grid item md={8} xs={12}>
          <StepDescription
            title="Coach programs"
            description="Select from this list of coach programs below.
                You can filter this list by the coach's available locations as well."
          />
          {hasLessonPacks && !coachIsViewingOwnSchedule && (
            <>
              <GroupedLessonTypes
                title="Buy Lesson Packs"
                selectedFacility={selectedFacility}
                lessonTypes={lessonTypesWithPacks}
                coachName={coachName}
                coachExternalId={coach?.externalId}
                classes={classes}
                isSingleSession={false}
              />
              <Divider />
            </>
          )}
          <GroupedLessonTypes
            title="Book a session"
            selectedFacility={selectedFacility}
            lessonTypes={lessonTypesSingleLesson}
            classes={classes}
            lessonCreditBalances={lessonCreditBalances}
            isSingleSession={true}
            coachExternalId={coach?.externalId}
            coachName={coachName}
            coachIsViewingOwnSchedule={coachIsViewingOwnSchedule}
          />
        </Grid>
        <Grid item md={3} xs={12} style={{ marginLeft: 'auto' }}>
          <CoachCardSm
            coach={{ name: coachName, coachAvatar, facilityName: coachTitle }}
          />
          <LocationDropdown
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
            locations={coachLocations}
          />
          {isLeadIntakeFormEnabled && !coachIsViewingOwnSchedule && (
            <>
              <Typography variant="h6" style={{ marginTop: '48px' }}>
                Not sure what to book?
              </Typography>
              <Typography variant="body1">
                {`If you aren't sure what session would be the best for you, send
                ${coachName} a message and he will help you find the right session for
                you.`}
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleGetInTouchClick}
                style={{
                  display: 'block',
                  width: '100%',
                  marginTop: '24px',
                  marginBottom: '24px',
                }}
              >
                Get in touch
              </Button>
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  )
}
